import { z } from 'zod/v4';
import { POSITION_ROLE_REGISTRY } from '../roles/position-roles.js';
const POSITION_ROLE_IDS = POSITION_ROLE_REGISTRY.map((role) => role.id);
export const CustomSpreadTemplateSchema = z
    .object({
    id: z.string().min(1),
    label: z.string().min(1),
    cards: z.number().int().min(1).max(20),
    family: z.enum(['single', 'triad', 'line', 'cross', 'horseshoe', 'wheel', 'mirror', 'tree', 'grid', 'custom']),
    layout_id: z.string().min(1),
    positions: z.array(z.object({
        role_id: z.union([z.enum(POSITION_ROLE_IDS), z.literal('custom')]),
        name: z.string().min(1),
        description: z.string().min(1),
    })),
    tags: z.array(z.enum([
        'temporal',
        'causal',
        'diagnostic',
        'conflict',
        'decision',
        'relational',
        'introspective',
        'initiatic',
        'ritual',
        'forecast',
        'healing',
        'shadow-work',
        'self-study',
    ])),
})
    .refine((value) => value.positions.length === value.cards, {
    message: 'Custom spread template positions must match cards.',
    path: ['positions'],
})
    .refine((value) => new Set(value.positions.map((position) => position.name.trim().toLowerCase())).size === value.positions.length, {
    message: 'Custom spread template position names must be unique.',
    path: ['positions'],
});
export const CustomSpreadTemplateJsonSchema = z.toJSONSchema(CustomSpreadTemplateSchema);
export const assertCustomSpreadTemplate = (template) => CustomSpreadTemplateSchema.parse(template);
//# sourceMappingURL=spread-template-schema.js.map